import { render, staticRenderFns } from "./WxBindLoginSelfDialog.vue?vue&type=template&id=fd877d04&scoped=true"
import script from "./WxBindLoginSelfDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WxBindLoginSelfDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WxBindLoginSelfDialog.vue?vue&type=style&index=0&id=fd877d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd877d04",
  null
  
)

export default component.exports